const SUBDOMAIN_ROLE_MAP = {
  admin: "admin",
  parent: "parent",
  school: "school",
  vendor: "vendor",
};

export const getSubdomainRole = () => {
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return null;
  const sub = host.split(".")[0].toLowerCase();
  return SUBDOMAIN_ROLE_MAP[sub] ?? null;
};
